import baseStyled, { css as baseCss, useTheme as baseUseTheme } from 'styled-components';
import omit from 'transmute/omit';
import { MIN_SIDEBAR_WIDTH, SIDEBAR_ANIMATION_DURATION_SECONDS } from '../constants/sidebar';
import { jsx as _jsx } from "react/jsx-runtime";
export function styledWithOmittedProps(Component, propsToIgnore = []) {
  const WithOmittedProps = props => /*#__PURE__*/_jsx(Component, Object.assign({}, omit(propsToIgnore, props)));
  return baseStyled(WithOmittedProps);
}
const getSidebarWidth = ({
  open
}) => {
  return `${open ? MIN_SIDEBAR_WIDTH : 0}px`;
};
export const getSidebarWidthStyles = props => {
  return {
    width: getSidebarWidth(props),
    minWidth: getSidebarWidth(props),
    maxWidth: '26vw',
    transition: `width ${SIDEBAR_ANIMATION_DURATION_SECONDS}s, min-width ${SIDEBAR_ANIMATION_DURATION_SECONDS}s`
  };
};
export const styled = baseStyled;
export const css = baseCss;
export const useTheme = baseUseTheme;